import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { formatFileSize } from '@/utils/storage';

interface SourceUploadModalPreviewUnavailableProps {
    fileName: string;
    fileSize: number;
}

export function SourceUploadModalPreviewUnavailable({
    fileName,
    fileSize,
}: SourceUploadModalPreviewUnavailableProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);

    return (
        <div className="w-full aspect-video bg-black-100 rounded flex flex-col items-center justify-center gap-3 text-grey-300">
            <div className="text-center px-4">
                <p className="text-base font-medium text-white-100">
                    {t('upload.previewUnavailable')}
                </p>
                <p className="text-sm text-grey-200 mt-2">
                    {t('upload.previewUnavailableDescription')}
                    <br />
                    {t('upload.processingAfterUpload')}
                </p>
            </div>
            <div className="text-sm text-grey-300 mt-2">
                {fileName} • {formatFileSize(fileSize)}
            </div>
        </div>
    );
}
